import React from 'react';
import Icon from '../../../components/AppIcon';

const ServiceBreakdown = () => {
  const services = [
    {
      icon: 'FileText',
      title: 'Employment Contracts',
      description: 'Comprehensive employment contract drafting, review, and negotiation to protect both employer and employee interests while ensuring legal compliance.'
    },
    {
      icon: 'Scale',
      title: 'Workplace Disputes',
      description: 'Professional dispute resolution for workplace conflicts, including mediation, arbitration, and litigation representation for employment-related matters.'
    },
    {
      icon: 'UserMinus',
      title: 'Termination Procedures',
      description: 'Guidance on proper termination procedures, severance packages, and ensuring compliance with statutory requirements for ending employment relationships.'
    },
    {
      icon: 'Shield',
      title: 'Discrimination Claims',
      description: 'Representation in discrimination cases covering gender, age, disability, and other protected categories, ensuring fair treatment in the workplace.'
    },
    {
      icon: 'Handshake',
      title: 'Collective Bargaining',
      description: 'Assistance with collective bargaining agreements, union negotiations, and industrial relations to maintain harmonious workplace environments.'
    },
    {
      icon: 'CheckCircle',
      title: 'Compliance Audits',
      description: 'Comprehensive workplace compliance audits to ensure adherence to labor laws, safety regulations, and best practices in human resource management.'
    }
  ];

  return (
    <section className="py-16 bg-gradient-to-br from-surface/10 to-primary/5">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl lg:text-4xl font-heading font-bold text-text-primary mb-4">
            Employment & Labor Law Services
          </h2>
          <p className="text-lg text-text-secondary max-w-2xl mx-auto">
            Comprehensive workplace legal services designed to protect your rights and ensure compliance with Kenya's labor laws.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div
              key={index}
              className="bg-white rounded-2xl p-8 shadow-md border border-border-light hover:shadow-lg transition-all duration-300 hover:-translate-y-1"
            >
              <div className="flex items-start space-x-4">
                <div className="flex-shrink-0 w-14 h-14 bg-gradient-to-br from-primary to-accent rounded-xl flex items-center justify-center">
                  <Icon name={service.icon} size={24} color="white" strokeWidth={2} />
                </div>
                <div className="flex-1">
                  <h3 className="text-xl font-heading font-semibold text-text-primary mb-3">
                    {service.title}
                  </h3>
                  <p className="text-text-secondary leading-relaxed">
                    {service.description}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServiceBreakdown;